import { render, staticRenderFns } from "./AppSummaryViewPlatinum.vue?vue&type=template&id=03299222&scoped=true"
import script from "./AppSummaryViewPlatinum.vue?vue&type=script&lang=js"
export * from "./AppSummaryViewPlatinum.vue?vue&type=script&lang=js"
import style0 from "./AppSummaryViewPlatinum.vue?vue&type=style&index=0&id=03299222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03299222",
  null
  
)

export default component.exports